<template>
  <div id="menu">
    <div id="menu-wrapper">
      <div id="menu-area" v-if="menuInfo != null">
        <div
          v-for="(category, index) in menuInfo.categoryList"
          :key="index"
          id="category-area"
        >
          <div class="category">
            <div class="label">{{ category.name }}</div>
          </div>
          <div class="menu-list">
            <router-link
              v-for="(menuItem, menuIndex) in category.menuList"
              v-show="menuItem.name"
              :key="menuIndex"
              :to="menuItem.path"
              class="menu"
            >
              <div
                class="label"
                :class="{ active: isMenuActive(menuItem) }"
              >
                {{ menuItem.name }}
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div id="menu-area" v-else></div>
      <div id="session-area" v-if="loginInfo.userId == 0">
        <div class="obj clickable theme-toggle" @click="toggleTheme()" :title="isDark() ? '라이트 모드로 전환' : '다크 모드로 전환'">
          {{ isDark() ? '☀️' : '🌙' }}
        </div>
        <div class="obj clickable" @click="clickLogin()">로그인</div>
        <div class="obj clickable" @click="clickJoin()">회원가입</div>
      </div>
      <div id="session-area" v-else>
        <div class="obj clickable theme-toggle" @click="toggleTheme()" :title="isDark() ? '라이트 모드로 전환' : '다크 모드로 전환'">
          {{ isDark() ? '☀️' : '🌙' }}
        </div>
        <div class="obj">{{ loginInfo.id }}</div>
        <div class="obj clickable" @click="clickMyInfo()">마이페이지</div>
        <div class="obj clickable" @click="clickLogout()">로그아웃</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from "vue";
import { useRoute } from "vue-router";
import UtilMixin from "@/common/mixins/UtilMixin";
import { useTheme } from "@/common/composables/useTheme";

import * as core from "@/common/utils/core";
import * as routerUtil from "@/common/utils/routerUtil";
import lottoMenu from "@/lotto/assets/json/menuInfo.json";
import instaMenu from "@/insta/assets/json/menuInfo.json";
import aptMenu from "@/apt/assets/json/menuInfo.json";
import familyEventMenu from "@/familyEvent/assets/json/menuInfo.json";
import closetMenu from "@/closet/assets/json/menuInfo.json";
import keywordMenu from "@/keyword/assets/json/menuInfo.json";
import adminMenu from "@/admin/assets/json/menuInfo.json";

interface MenuItem {
  name: string;
  path: string;
  matchPaths?: string[];
}

interface Category {
  name: string;
  menuList: MenuItem[];
}

export default defineComponent({
  name: "MenuComponent",

  setup() {
    const route = useRoute();
    const currentPath = ref(route.path);
    const menuInfo = ref<{ categoryList: Category[] } | null>(null);
    const { toggleTheme, isDark } = useTheme();

    const fetchMenuInfo = async () => {
      if (currentPath.value.startsWith("/lotto")) {
        try {
          menuInfo.value = lottoMenu;
        } catch (error) {
          console.error("Failed to load menuInfo.json:", error);
        }
      } else if (currentPath.value.startsWith("/insta")) {
        try {
          menuInfo.value = instaMenu;
        } catch (error) {
          console.error("Failed to load menuInfo.json:", error);
        }
      } else if (currentPath.value.startsWith("/apt")) {
        try {
          menuInfo.value = aptMenu;
        } catch (error) {
          console.error("Failed to load menuInfo.json:", error);
        }
      } else if (currentPath.value.startsWith("/family-event")) {
        try {
          menuInfo.value = familyEventMenu;
        } catch (error) {
          console.error("Failed to load menuInfo.json:", error);
        }
      } else if (currentPath.value.startsWith("/closet")) {
        try {
          menuInfo.value = closetMenu;
        } catch (error) {
          console.error("Failed to load menuInfo.json:", error);
        }
      } else if (currentPath.value.startsWith("/keyword")) {
        try {
          menuInfo.value = keywordMenu;
        } catch (error) {
          console.error("Failed to load menuInfo.json:", error);
        }
      } else if (currentPath.value.startsWith("/admin")) {
        try {
          menuInfo.value = adminMenu;
        } catch (error) {
          console.error("Failed to load menuInfo.json:", error);
        }
      } else {
        menuInfo.value = null;
      }
    };

    watch(
      () => route.path,
      (newPath) => {
        currentPath.value = newPath;
        fetchMenuInfo();
      },
      { immediate: true }
    );

    onMounted(() => {
      fetchMenuInfo();
    });

    const isMenuActive = (menuItem: MenuItem): boolean => {
      if (currentPath.value === menuItem.path) return true;
      if (menuItem.matchPaths) {
        return menuItem.matchPaths.some((p) => currentPath.value.startsWith(p));
      }
      return false;
    };

    return {
      menuInfo,
      currentPath,
      isMenuActive,
      toggleTheme,
      isDark,
    };
  },
  data() {
    return {};
  },
  mixins: [UtilMixin],
  computed: {
    loginInfo() {
      return core.getLoginInfo();
    },
  },

  methods: {
    clickLogin() {
      console.log("click login");
      const nextRoute = this.getRouterUtil().getCreateNextRoute();
      routerUtil.moveTo("/user/login", nextRoute);
    },
    clickMyInfo() {
      routerUtil.moveTo("/user/info");
    },
    clickJoin() {
      routerUtil.moveTo("/user/join");
    },
    async clickLogout() {
      console.log("click logout");
      // core.logout();
      const res = await this.getApi().user().logout();
      if (res.success) {
        alert("로그아웃 되었습니다.");
        core.logoutSuccess();
      }
    },
  },
});
</script>
